import moment from "moment";

export default {
	methods: {
		moment() {
			return moment;
		},
		setDateFormat(date) {
			return moment(date).format("DD MMM, YYYY");
		},
		getName(){

		},
		prepareForm(data) {
			let params = new FormData();
			for (let fieldName in data) {
				let fieldValue = data[fieldName];
				if (typeof fieldValue !== "object") {
					params.set(fieldName, fieldValue);
				} else {
					if (fieldValue && Array.isArray(fieldValue)) {
						if (fieldValue.length > 0) {
							for (let index in fieldValue) {
								params.set(
									fieldName + "[" + index + "]",
									fieldValue[index].id || fieldValue[index]
								);
							}
						} else {
							params.set(fieldName, fieldValue);
						}
					} else {
						if (fieldValue && fieldValue.id) {
							params.set(fieldName + "_id", fieldValue.id);
						} else {
							params.set(fieldName, fieldValue || "");
						}
					}
				}
			}
			return params;
		},
		objectToFormData(obj, form, namespace) {
			var fd = form || new FormData();
			var formKey;
			for (var property in obj) {
				if (obj.hasOwnProperty(property)) {
					if (namespace) {
						formKey = namespace + "[" + property + "]";
					} else {
						formKey = property;
					}
					// if the property is an object, but not a File,
					// use recursivity.
					if (obj[property] instanceof Date) {
						fd.append(formKey, this.moment(obj[property]).format());
					} else if (
						typeof obj[property] === "object" &&
						!(obj[property] instanceof File)
					) {
						this.objectToFormData(obj[property], fd, formKey);
					} else {
						// if it's a string or a File object
						fd.append(formKey, obj[property]);
					}
				}
			}
			return fd;
		},
		previewMedia(
			value = "",
			default_image = "/assets/images/product-image.png"
		) {
			if (value instanceof File) {
				return URL.createObjectURL(value);
			} else if (value instanceof Object) {
				if (value.collection_name == "video") {
					return value.original;
				} else {
					return value.url;
				}
			} else {
				return `${default_image}`;
			}
		},
		containsAny(array1, array2) {
			return array1.some((e) => array2.indexOf(e) >= 0);
		},
		capitalize(value) {
			if (!value) return "";
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1);
		},
		addQueryString(url = "", query) {
			if (!query) return url;
			var arrayQuery = [];
			var i = 0;
			for (let key in query) {
				arrayQuery[i] = key + "=" + query[key];
				i++;
			}
			return url + "?" + arrayQuery.join("&");
		},
		/**
		 * Granular permission check for showing/hiding action buttons.
		 * Reads the logged-in user's permission slugs (set at login into
		 * userData.permissions). Owner and super_admin always bypass and
		 * see everything. Usage in templates: v-if="hasPermission('update_source')".
		 */
		hasPermission(slug) {
			const raw =
				sessionStorage.getItem("userData") ||
				localStorage.getItem("userData");
			const u = raw ? JSON.parse(raw) : null;
			if (!u) return false;
			const roles = [];
			if (u.role) roles.push(String(u.role).toLowerCase());
			if (Array.isArray(u.roles)) {
				u.roles.forEach((r) =>
					roles.push(
						String(typeof r === "object" ? r.name || r.slug : r).toLowerCase()
					)
				);
			}
			if (roles.includes("owner") || roles.includes("super_admin")) return true;
			const perms = Array.isArray(u.permissions) ? u.permissions : [];
			return perms.includes(slug);
		},
		/**
		 * Company-level master switch (companies.can_edit) — set by Super
		 * Admin per company. When false, NOBODY at that company (not even
		 * the owner) can edit/delete data entries.
		 */
		companyCanEdit() {
			const raw =
				sessionStorage.getItem("userData") ||
				localStorage.getItem("userData");
			const u = raw ? JSON.parse(raw) : null;
			return !!(u && u.company && u.company.can_edit);
		},
		/**
		 * Resolved permission to show Edit/Delete buttons on Data Entry
		 * list screens: company master switch must be ON, AND (owner, who
		 * always passes hasPermission, OR the user's role has the specific
		 * update_data_entry / delete_data_entry permission).
		 */
		canEditDataEntry() {
			return this.companyCanEdit() && this.hasPermission("update_data_entry");
		},
		canDeleteDataEntry() {
			return this.companyCanEdit() && this.hasPermission("delete_data_entry");
		},
		/**
		 * Shared confirm + DELETE + toast flow for Data Entry list screens.
		 * Usage: this.deleteDataEntry(url).then((ok) => { if (ok) this.getXList(); });
		 */
		deleteDataEntry(url) {
			const axiosIns = require("@/libs/axios").default;
			const ToastificationContent = require("@core/components/toastification/ToastificationContent.vue").default;
			return this.$bvModal
				.msgBoxConfirm("Are you sure you want to delete this entry? This cannot be undone.", {
					title: "Confirm Delete",
					okVariant: "danger",
					okTitle: "Delete",
					cancelTitle: "Cancel",
					centered: true,
				})
				.then((confirmed) => {
					if (!confirmed) return false;
					return axiosIns
						.delete(url)
						.then(() => {
							this.$toast({
								component: ToastificationContent,
								position: "top-right",
								props: {
									icon: "CoffeeIcon",
									variant: "success",
									text: "Entry deleted successfully",
								},
							});
							return true;
						})
						.catch((error) => {
							const msg = error.response?.data?.message || "Failed to delete entry";
							this.$toast({
								component: ToastificationContent,
								position: "top-right",
								props: {
									icon: "CoffeeIcon",
									variant: "danger",
									text: msg,
								},
							});
							return false;
						});
				});
		},
	},
};
